import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import type { AppelsStats } from "@shared/modules/x-appels";
import { Badge } from "../../../core/components/ui/badge";
import { Card } from "../../../core/components/ui/card";
import { getStats } from "../lib/api";

type State = { kind: "loading" } | { kind: "failed" } | { kind: "ready"; stats: AppelsStats };

/** Le répondeur aujourd'hui : appels, en cours, manqués, rendez-vous pris. */
export function AppelsWidget() {
  const [state, setState] = useState<State>({ kind: "loading" });

  useEffect(() => {
    let cancelled = false;
    const load = () =>
      getStats()
        .then((stats) => {
          if (!cancelled) setState({ kind: "ready", stats });
        })
        .catch(() => {
          if (!cancelled) setState({ kind: "failed" });
        });
    void load();
    const timer = setInterval(load, 10_000);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, []);

  return (
    <Card
      title="Répondeur IA"
      subtitle="Les appels que l'assistante a pris aujourd'hui."
      actions={<Link to="/appels">Voir les appels</Link>}
    >
      {state.kind === "loading" ? (
        <p className="appels-widget__empty">Chargement…</p>
      ) : state.kind === "failed" ? (
        <p className="appels-widget__empty">Appels indisponibles pour l'instant.</p>
      ) : (
        <dl className="appels-widget__stats">
          <div className="appels-widget__stat">
            <dt className="appels-widget__label">Appels</dt>
            <dd className="appels-widget__value">{state.stats.today}</dd>
          </div>
          <div className="appels-widget__stat">
            <dt className="appels-widget__label">En cours</dt>
            <dd className="appels-widget__value">
              {state.stats.inProgress > 0 ? (
                <Badge variant="live">{state.stats.inProgress}</Badge>
              ) : (
                "0"
              )}
            </dd>
          </div>
          <div
            className={`appels-widget__stat${state.stats.missedToday > 0 ? " appels-widget__stat--alert" : ""}`}
          >
            <dt className="appels-widget__label">Manqués</dt>
            <dd className="appels-widget__value">{state.stats.missedToday}</dd>
          </div>
          <div className="appels-widget__stat appels-widget__stat--good">
            <dt className="appels-widget__label">RDV pris</dt>
            <dd className="appels-widget__value">{state.stats.bookedToday}</dd>
          </div>
        </dl>
      )}
    </Card>
  );
}
